import { put, throttle } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { SEARCH_APPS, SearchAppsAction, searchAppsEnd } from "../actions";

export function* searchApps(action: SearchAppsAction) {
    const { payload } = action;
    const { params } = payload;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.searchApps(params);
        yield put(searchAppsEnd(undefined, result));
    } catch (e) {
        yield put(searchAppsEnd(e));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchSearchApps() {
    yield throttle(300, SEARCH_APPS, searchApps);
}
